export default "__VITE_ASSET__aDVqQxP3__"